import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openCitySelect } from '@r1-frontend/entities/Layout/CitySelectContainer/store/actionCreators';
import { getCurrentCity } from '@r1-frontend/entities/stores/city/selectors';

import { Location } from '@r1-frontend/ui-react/components/svg/location';

import * as ST from './styled';

export interface IProps {
    className?: string,
}

export const CitySelect = ({ className }: IProps) => {
    const dispatch = useDispatch();
    const city = useSelector(getCurrentCity);
    const openCitySelectHandler = () => dispatch(openCitySelect());

    return <ST.CityWrapper
        role='button'
        onClick={openCitySelectHandler}
        data-test='city-select-btn'
        className={className}
    >
        <Location size={16}/>
        <span>{city ? city.name : null}</span>
    </ST.CityWrapper>;
};
